var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 90,
    height: "",
    viewBox: "0 0 108 59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_1",
    "data-name": "Mask Group 1",
    transform: "translate(0.524 -0.428)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "alert",
    d: "M67.193,56.508A6.639,6.639,0,0,1,61.4,59.8H6.7A6.639,6.639,0,0,1,.907,56.508a6.427,6.427,0,0,1,0-6.583L28.258,3.292a6.741,6.741,0,0,1,11.583,0L67.193,49.924a6.429,6.429,0,0,1,0,6.583ZM34.05,38.21A4.354,4.354,0,0,0,38.433,33.9V14.1a2.06,2.06,0,0,0-2.076-2.044H31.743A2.06,2.06,0,0,0,29.667,14.1V33.9A4.354,4.354,0,0,0,34.05,38.21ZM38.4,47.928a4.354,4.354,0,1,0-4.353,4.285A4.324,4.324,0,0,0,38.4,47.928Z",
    transform: "translate(19.426 0.028)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.2e93f87f2d9afc28be93779aecc42ff9.svg";
export { ForwardRef as ReactComponent };